export default {
    recommendGuide: "",
    expandNodeGuide: "/assets/guide/network_line.png",
}